import React, { useState } from 'react';
import Modal from 'react-modal'; // Assurez-vous d'avoir installé react-modal
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '90vw',  // 90% de la largeur de la fenêtre pour plus d'espace
    height: '80vh',  // 80% de la hauteur de la fenêtre
    padding: 0,
    borderRadius: '10px',
  },
  overlay: {
    zIndex: 999,
  }
};

const App: React.FC = () => {
  const [isFirstModalOpen, setIsFirstModalOpen] = useState(false);
  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
  const [isThirdModalOpen, setIsThirdModalOpen] = useState(false);
  const [isFourthModalOpen, setIsFourthModalOpen] = useState(false);

  const handleOpenFirstModal = () => {
    setIsFirstModalOpen(true);
  };

  const handleOpenSecondModal = () => {
    setIsSecondModalOpen(true);
  };

  const handleOpenThirdModal = () => {
    setIsThirdModalOpen(true);
  };

  const handleOpenFourthModal = () => {
    setIsFourthModalOpen(true);
  };

  const [isDarkMode, setIsDarkMode] = useState(false);

  // Fonction pour basculer entre les modes
  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);

  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false)
  };

  const [formData, setFormData] = useState({
    name: '',
    lastname: '',
    email: '',
    service: '',
    message: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const sendEmail = (e) => {
    e.preventDefault();
  
    const templateParams = {
      name: formData.name,
      lastname: formData.lastname,
      email: formData.email,
      service: formData.service,
      message: formData.message,
    };
  
    emailjs.send(
      'service_tkjal6m', // ID de service EmailJS
      'template_foocsgm', // ID de template EmailJS
      templateParams, // Données du formulaire
      'JXpJkh56iGNtq03GS' // User ID EmailJS
    )
    .then((result) => {
      console.log(result.text);
      
      // Notification de succès avec Toastify
      toast.success('Votre message a été envoyé avec succès!', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      
      // Réinitialiser le formulaire
      setFormData({
        name: '',
        lastname: '',
        email: '',
        service: '',
        message: '',
      });
  
      // Fermer le modal
      closeModal();
    }, (error) => {
      console.log(error.text);
      
      // Notification d'erreur avec Toastify
      toast.error('Erreur lors de l\'envoi du message.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
  };
  
  return (
    <div className="bg-gray-900 text-white {isDarkMode ? 'dark' : ''}">
      {/* Hero Section */}
      <>
        {/* Autres composants */}
        <ToastContainer />
      </>
      <section className="bg-cover bg-center transition-all duration-500"
        style={{
          backgroundImage: isDarkMode
            ? 'url("img/AdobeStock_260637981.jpeg")'
            : 'url("img/maze white.jpg")',
        }}>
        <header className="flex justify-center items-center h-60">
          {/* Logo avec événement onClick */}
          <img src="/img/zhm.png" alt="Logo" className="h-32 w-32 md:h-40 md:w-40 lg:h-48 lg:w-48 cursor-pointer" onClick={handleOpenFirstModal}/> 

          {/* Modal pour le pop-up YouTube */}
          <Modal
            isOpen={isFirstModalOpen}
            onRequestClose={() => setIsFirstModalOpen(false)} 
            style={customStyles}
          >
            {/* Bouton pour fermer le modal */}
            <button onClick={() => setIsFirstModalOpen(false)} className="close-button">
              Fermer
            </button>
            {/* Contenu du modal */}
            <iframe
              width="100%"    
              height="100%"   
              src="https://www.youtube.com/embed/4pV4T1hpkMk?autoplay=1"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
              allowFullScreen
            ></iframe>
          </Modal>  
        </header>
        
        {/* Bouton pour basculer entre les modes */}
        <button
          className="relative mx-auto flex items-center justify-center px-6 py-3 bg-black text-white font-semibold rounded-full shadow-lg hover:bg-cyan-600 transition-colors duration-300 focus:outline-none focus:ring-4 focus:ring-cyan-300"
          onClick={toggleDarkMode}
                >
          {isDarkMode ? (
            <svg className="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m6.364 1.636l-.707.707M21 12h-1M16.364 18.364l-.707-.707M12 21v-1M7.636 18.364l-.707-.707M3 12h1m1.636-4.364l.707.707M12 9a3 3 0 100 6 3 3 0 000-6z" />
            </svg>
          )  : (
            <svg className="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3a9 9 0 000 18 9 9 0 000-18z" />
            </svg>
          )}
        </button>

        {/* Section Services incluse dans le Hero */}
        <div className="relative z-10 container mx-auto mt-12">
          {/* Grille responsive avec 1 carte sur mobile, 2 sur tablette, 3 sur grand écran, 5 sur très grands écrans */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
            {/* Service 1-ZHTECH */}
            <div className="bg-black shadow-lg rounded-lg p-6 relative">
              {/* Contour brillant blanc */}
              <div className="absolute inset-0 border-2 border-white rounded-lg glow-card pointer-events-none"></div>  
              {/* Image avec événement pour ouvrir le second modal */}
              <img src="/img/zhtech.png" alt="IT Service" className="h-26 mx-auto mb-4 cursor-pointer" onClick={handleOpenSecondModal} />

              {/* Modal pour le pop-up YouTube */}
              <Modal
                isOpen={isSecondModalOpen}
                onRequestClose={() => setIsSecondModalOpen(false)} 
                style={customStyles}
              >
                {/* Bouton pour fermer le modal */}
                <button onClick={() => setIsSecondModalOpen(false)} className="close-button">
                  Fermer
                </button>
                {/* Contenu du modal */}
                <iframe
                  width="100%"    
                  height="100%"   
                  src="https://youtube.com/embed/playlist?list=PL8FDrrIOQuqAOcKZZWA511Rh6dfQKYpxw&feature=shared"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                  allowFullScreen
                ></iframe>
              </Modal>  
                    
              <p className="text-sky-500 text-center font-bold text-xl md:text-2xl lg:text-4xl">
              À PARTIR DE 45€
              </p>
              <div className="bg-opacity-40 backdrop-blur-lg p-4 text-center mt-4">
                <p className="text-white text-lg md:text-xl lg:text-2xl">MIGRATION</p>
                <hr className="my-2 border-sky-500"/>
                <p className="text-white text-lg md:text-xl lg:text-2xl">DÉPLOIEMENT</p>
                <hr className="my-2 border-sky-500"/>                
                <p className="text-white text-lg md:text-xl lg:text-2xl">MAINTENANCE</p>
              </div>
              <p className="text-sky-500 text-center font-bold text-lg md:text-xl lg:text-4xl mt-4">
                +1500H
              </p>
              <p className="text-center font-bold text-lg md:text-xl lg:text-2xl">
                D'EXPÉRIENCES
              </p>
              <p className="text-sky-500 text-center font-bold text-lg md:text-xl lg:text-4xl mt-4">
                +450
              </p>
              <p className="text-center font-bold text-lg md:text-xl lg:text-2xl">
                INTERVENTIONS
              </p>
            </div>
            {/* Service 2-ZHWEB */}
            <div className="bg-black shadow-lg rounded-lg p-6 relative">
            {/* Contour brillant blanc */}
              <div className="absolute inset-0 border-2 border-white rounded-lg glow-card pointer-events-none"></div>  
              {/* Image avec événement pour ouvrir le second modal */}
              <img src="/img/zhweb.png" alt="Web Development Service" className="h-26 mx-auto mb-4 cursor-pointer" onClick={handleOpenThirdModal} />

              {/* Modal pour le pop-up YouTube */}
              <Modal
                isOpen={isThirdModalOpen}
                onRequestClose={() => setIsThirdModalOpen(false)} 
                style={customStyles}
              >
                {/* Bouton pour fermer le modal */}
                <button onClick={() => setIsThirdModalOpen(false)} className="close-button">
                  Fermer
                </button>
                {/* Contenu du modal */}
                <iframe
                  width="100%"    
                  height="100%"   
                  src="https://youtube.com/embed/playlist?list=PL8FDrrIOQuqD1MvzDSlJ6FTP8FvkWycXg&feature=shared"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                  allowFullScreen
                ></iframe>
              </Modal>  
                    
              <p className="text-yellow-400 text-center font-bold text-xl md:text-xl lg:text-4xl">
              À PARTIR DE 299€
              </p>
              <div className="bg-opacity-40 backdrop-blur-lg p-6 text-center mt-4">
                <p className="text-white text-lg md:text-xl lg:text-2xl">SITE ONE-PAGE(UNE PAGE)</p>
                <hr className="my-2 border-yellow-400"/>
                <p className="text-white text-lg md:text-xl lg:text-2xl">SITE VITRINE</p>
                <hr className="my-2 border-yellow-400"/>
                <p className="text-white text-lg md:text-xl lg:text-2xl">BLOG</p>
                <hr className="my-2 border-yellow-400"/>
                <p className="text-white text-lg md:text-xl lg:text-2xl">E-COMMERCE</p>
              </div>
              <p className="text-yellow-400 text-center font-bold text-lg md:text-xl lg:text-4xl mt-4">
                +2000H
              </p>
              <p className="text-center font-bold text-lg md:text-xl lg:text-2xl">
                D'EXPÉRIENCES
              </p>
              <p className="text-yellow-400 text-center font-bold text-lg md:text-xl lg:text-4xl mt-4">
                +10
              </p>
              <p className="text-center font-bold text-lg md:text-xl lg:text-2xl">
                SITES
              </p>
            </div>

            {/* Service 3-ZHMOTION */}
            <div className="bg-black shadow-lg rounded-lg p-6 relative">
            {/* Contour brillant blanc */}
              <div className="absolute inset-0 border-2 border-white rounded-lg glow-card pointer-events-none"></div>  
              {/* Image avec événement pour ouvrir le quatrième modal */}
              <img src="/img/zhmotion.png" alt="Video and Editing Service" className="h-26 mx-auto mb-4 cursor-pointer" onClick={handleOpenFourthModal}/>

              {/* Modal pour le pop-up YouTube */}
              <Modal
                isOpen={isFourthModalOpen}
                onRequestClose={() => setIsFourthModalOpen(false)} 
                style={customStyles}
              >
                {/* Bouton pour fermer le modal */}
                <button onClick={() => setIsFourthModalOpen(false)} className="close-button">
                  Fermer
                </button>
                {/* Contenu du modal */}
                <iframe
                  width="100%"    
                  height="100%"   
                  src="https://youtube.com/embed/playlist?list=PL8FDrrIOQuqCPkDSm7x5OYf_Mtj1NBPNG&feature=shared"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                  allowFullScreen
                ></iframe>
              </Modal>  

              <p className="text-yellow-800 text-center font-bold text-xl md:text-2xl lg:text-4xl">
              À PARTIR DE 99€
              </p>
              
              <div className="bg-opacity-40 backdrop-blur-lg p-6 text-center mt-4">
                <p className="text-white text-lg md:text-xl lg:text-2xl">FILM D'ENTREPRISE</p>
                <hr className="my-2 border-yellow-800"/>
                <p className="text-white text-lg md:text-xl lg:text-2xl">FILM INTRO/OUTRO</p>
                <hr className="my-2 border-yellow-800"/>
                <p className="text-white text-lg md:text-xl lg:text-2xl">ANIMATION LOGO</p>
                <hr className="my-2 border-yellow-800"/>
                <p className="text-white text-lg md:text-xl lg:text-2xl">PODCAST</p>
              </div>
              <p className="text-yellow-800 text-center font-bold text-lg md:text-xl lg:text-4xl mt-4">
              +11000H
              </p>
              <p className="text-center font-bold text-lg md:text-xl lg:text-2xl">
                D'EXPÉRIENCES
              </p>
              <p className="text-yellow-800 text-center font-bold text-lg md:text-xl lg:text-4xl mt-4">
              +300
              </p>
              <p className="text-center font-bold text-lg md:text-xl lg:text-2xl">
                RÉALISATIONS
              </p>
            </div>
            {/* Service 4-ZHPHOTOS */}
            <div className="bg-black shadow-lg rounded-lg p-6 relative">
            {/* Contour brillant blanc */}
              <div className="absolute inset-0 border-2 border-white rounded-lg glow-card pointer-events-none"></div>  
              {/* Image avec événement pour ouvrir le second modal */}
              <img src="/img/zhphotos.png" alt="Photos Service" className="h-26 mx-auto mb-4"/>   
              <p className="text-green-500 text-center font-bold text-xl md:text-2xl lg:text-4xl">
              À PARTIR DE 39€
              </p>
              <div className="bg-opacity-40 backdrop-blur-lg p-6 text-center mt-4">
                <p className="text-white text-lg md:text-xl lg:text-2xl">CUISINE / TRAITEUR</p>
                <hr className="my-2 border-green-500"/>
                <p className="text-white text-lg md:text-xl lg:text-2xl">PARFUMERIE</p>
                <hr className="my-2 border-green-500"/>
                <p className="text-white text-lg md:text-xl lg:text-2xl">PRÊT-À-PORTER</p>
                <hr className="my-2 border-green-500"/>
                <p className="text-white text-lg md:text-xl lg:text-1xl">VOYAGE / ARCHITECTURE</p>
              </div>
              <p className="text-green-500 text-center font-bold text-lg md:text-xl lg:text-4xl mt-4">
                +1300H
              </p>
              <p className="text-center font-bold text-lg md:text-xl lg:text-2xl">
                D'EXPÉRIENCES
              </p>
              <p className="text-green-500 text-center font-bold text-lg md:text-xl lg:text-4xl mt-4">
                +5000
              </p>
              <p className="text-center font-bold text-lg md:text-xl lg:text-2xl">
                PHOTOS
              </p>
            </div>
            {/* Service 5-ZHDESIGN */}
            <div className="bg-black shadow-lg rounded-lg p-6 relative">
            {/* Contour brillant blanc */}
              <div className="absolute inset-0 border-2 border-white rounded-lg glow-card pointer-events-none"></div>  
              {/* Image avec événement pour ouvrir le second modal */}
              <img src="/img/zhdesign.png" alt="Design Service" className="h-26 mx-auto mb-4" />
    
              <p className="text-red-600 text-center font-bold text-xl md:text-2xl lg:text-4xl">
              À PARTIR DE 50€
              </p>
              <div className="bg-opacity-40 backdrop-blur-lg p-6 text-center mt-4">
                <p className="text-white text-lg md:text-xl lg:text-2xl">LOGO / MOCKUP</p>
                <hr className="my-2 border-red-600"/>
                <p className="text-white text-lg md:text-xl lg:text-2xl">FLYER / AFFICHE</p>
                <hr className="my-2 border-red-600"/>
                <p className="text-white text-lg md:text-xl lg:text-2xl">DESIGN SITE INTERNET</p>
              </div>
              <p className="text-red-600 text-center font-bold text-lg md:text-xl lg:text-4xl mt-4">
              +250H
              </p>
              <p className="text-center font-bold text-lg md:text-xl lg:text-2xl">
                D'EXPÉRIENCES
              </p>
              <p className="text-red-600 text-center font-bold text-lg md:text-xl lg:text-4xl mt-4">
               +40
              </p>
              <p className="text-center font-bold text-lg md:text-xl lg:text-2xl">
                PROJETS
              </p>
            </div>
          </div>
        </div>

        {/*Social Icons*/}
        <div className="w-full h-auto py-8 flex items-center justify-center gap-4 flex-wrap">
          {/* Facebook icon */}
          <a
            href="https://www.facebook.com/zhmultimedia/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 flex items-center relative overflow-hidden justify-center rounded-full bg-white shadow-md shadow-gray-200 group transition-all duration-300"
          >            
           <svg className="relative z-10 fill-gray-900 transition-all duration-300 group-hover:fill-white" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 72 72" fill="none">
              <path
                d="M46.4927 38.6403L47.7973 30.3588H39.7611V24.9759C39.7611 22.7114 40.883 20.4987 44.4706 20.4987H48.1756V13.4465C46.018 13.1028 43.8378 12.9168 41.6527 12.8901C35.0385 12.8901 30.7204 16.8626 30.7204 24.0442V30.3588H23.3887V38.6403H30.7204V58.671H39.7611V38.6403H46.4927Z"
                fill="" />
            </svg>
            <div className="absolute top-full left-0 w-full h-full rounded-full bg-blue-500 z-0 transition-all duration-500 group-hover:top-0"></div>
          </a>
      
          {/* Instagram button */}
          <a
            href="https://www.instagram.com/zhm_ca_fonctionne/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 flex items-center relative overflow-hidden justify-center rounded-full bg-white shadow-md shadow-gray-200 group transition-all duration-300"
          >            
          <svg className="fill-gray-900 relative z-10 transition-all duration-500 group-hover:fill-white" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 51 51" fill="none">
            <path
              d="M17.4456 25.7808C17.4456 21.1786 21.1776 17.4468 25.7826 17.4468C30.3875 17.4468 34.1216 21.1786 34.1216 25.7808C34.1216 30.383 30.3875 34.1148 25.7826 34.1148C21.1776 34.1148 17.4456 30.383 17.4456 25.7808ZM12.9377 25.7808C12.9377 32.8708 18.6883 38.618 25.7826 38.618C32.8768 38.618 38.6275 32.8708 38.6275 25.7808C38.6275 18.6908 32.8768 12.9436 25.7826 12.9436C18.6883 12.9436 12.9377 18.6908 12.9377 25.7808ZM36.1342 12.4346C36.1339 13.0279 36.3098 13.608 36.6394 14.1015C36.9691 14.595 37.4377 14.9797 37.9861 15.2069C38.5346 15.4342 39.1381 15.4939 39.7204 15.3784C40.3028 15.2628 40.8378 14.9773 41.2577 14.5579C41.6777 14.1385 41.9638 13.6041 42.0799 13.0222C42.1959 12.4403 42.1367 11.8371 41.9097 11.2888C41.6828 10.7406 41.2982 10.2719 40.8047 9.94202C40.3112 9.61218 39.7309 9.436 39.1372 9.43576H39.136C38.3402 9.43613 37.5771 9.75216 37.0142 10.3144C36.4514 10.8767 36.1349 11.6392 36.1342 12.4346ZM15.6765 46.1302C13.2377 46.0192 11.9121 45.6132 11.0311 45.2702C9.86323 44.8158 9.02993 44.2746 8.15381 43.4002C7.27768 42.5258 6.73536 41.6938 6.28269 40.5266C5.93928 39.6466 5.53304 38.3214 5.42217 35.884C5.3009 33.2488 5.27668 32.4572 5.27668 25.781C5.27668 19.1048 5.3029 18.3154 5.42217 15.678C5.53324 13.2406 5.94248 11.918 6.28269 11.0354C6.73736 9.86816 7.27888 9.03536 8.15381 8.15976C9.02873 7.28416 9.86123 6.74216 11.0311 6.28976C11.9117 5.94656 13.2377 5.54056 15.6765 5.42976C18.3133 5.30856 19.1054 5.28436 25.7826 5.28436C32.4598 5.28436 33.2527 5.31056 35.8916 5.42976C38.3305 5.54076 39.6539 5.94976 40.537 6.28976C41.7049 6.74216 42.5382 7.28536 43.4144 8.15976C44.2905 9.03416 44.8308 9.86816 45.2855 11.0354C45.6289 11.9154 46.0351 13.2406 46.146 15.678C46.2673 18.3154 46.2915 19.1048 46.2915 25.781C46.2915 32.4572 46.2673 33.2466 46.146 35.884C46.0349 38.3214 45.6267 39.6462 45.2855 40.5266C44.8308 41.6938 44.2893 42.5266 43.4144 43.4002C42.5394 44.2738 41.7049 44.8158 40.537 45.2702C39.6565 45.6134 38.3305 46.0194 35.8916 46.1302C33.2549 46.2514 32.4628 46.2756 25.7826 46.2756C19.1024 46.2756 18.3125 46.2514 15.6765 46.1302ZM15.4694 0.932162C12.8064 1.05336 10.9867 1.47536 9.39755 2.09336C7.75177 2.73156 6.35853 3.58776 4.9663 4.97696C3.57406 6.36616 2.71955 7.76076 2.08097 9.40556C1.46259 10.9948 1.04034 12.8124 0.919069 15.4738C0.795795 18.1394 0.767578 18.9916 0.767578 25.7808C0.767578 32.57 0.795795 33.4222 0.919069 36.0878C1.04034 38.7494 1.46259 40.5668 2.08097 42.156C2.71955 43.7998 3.57426 45.196 4.9663 46.5846C6.35833 47.9732 7.75177 48.8282 9.39755 49.4682C10.9897 50.0862 12.8064 50.5082 15.4694 50.6294C18.138 50.7506 18.9893 50.7808 25.7826 50.7808C32.5759 50.7808 33.4286 50.7526 36.0958 50.6294C38.759 50.5082 40.5774 50.0862 42.1676 49.4682C43.8124 48.8282 45.2066 47.9738 46.5989 46.5846C47.9911 45.1954 48.8438 43.7998 49.4842 42.156C50.1026 40.5668 50.5268 38.7492 50.6461 36.0878C50.7674 33.4202 50.7956 32.57 50.7956 25.7808C50.7956 18.9916 50.7674 18.1394 50.6461 15.4738C50.5248 12.8122 50.1026 10.9938 49.4842 9.40556C48.8438 7.76176 47.9889 6.36836 46.5989 4.97696C45.2088 3.58556 43.8124 2.73156 42.1696 2.09336C40.5775 1.47536 38.7588 1.05136 36.0978 0.932162C33.4306 0.810962 32.5779 0.780762 25.7846 0.780762C18.9913 0.780762 18.138 0.808962 15.4694 0.932162Z"
              fill="" />
            <path
              d="M17.4456 25.7808C17.4456 21.1786 21.1776 17.4468 25.7826 17.4468C30.3875 17.4468 34.1216 21.1786 34.1216 25.7808C34.1216 30.383 30.3875 34.1148 25.7826 34.1148C21.1776 34.1148 17.4456 30.383 17.4456 25.7808ZM12.9377 25.7808C12.9377 32.8708 18.6883 38.618 25.7826 38.618C32.8768 38.618 38.6275 32.8708 38.6275 25.7808C38.6275 18.6908 32.8768 12.9436 25.7826 12.9436C18.6883 12.9436 12.9377 18.6908 12.9377 25.7808ZM36.1342 12.4346C36.1339 13.0279 36.3098 13.608 36.6394 14.1015C36.9691 14.595 37.4377 14.9797 37.9861 15.2069C38.5346 15.4342 39.1381 15.4939 39.7204 15.3784C40.3028 15.2628 40.8378 14.9773 41.2577 14.5579C41.6777 14.1385 41.9638 13.6041 42.0799 13.0222C42.1959 12.4403 42.1367 11.8371 41.9097 11.2888C41.6828 10.7406 41.2982 10.2719 40.8047 9.94202C40.3112 9.61218 39.7309 9.436 39.1372 9.43576H39.136C38.3402 9.43613 37.5771 9.75216 37.0142 10.3144C36.4514 10.8767 36.1349 11.6392 36.1342 12.4346ZM15.6765 46.1302C13.2377 46.0192 11.9121 45.6132 11.0311 45.2702C9.86323 44.8158 9.02993 44.2746 8.15381 43.4002C7.27768 42.5258 6.73536 41.6938 6.28269 40.5266C5.93928 39.6466 5.53304 38.3214 5.42217 35.884C5.3009 33.2488 5.27668 32.4572 5.27668 25.781C5.27668 19.1048 5.3029 18.3154 5.42217 15.678C5.53324 13.2406 5.94248 11.918 6.28269 11.0354C6.73736 9.86816 7.27888 9.03536 8.15381 8.15976C9.02873 7.28416 9.86123 6.74216 11.0311 6.28976C11.9117 5.94656 13.2377 5.54056 15.6765 5.42976C18.3133 5.30856 19.1054 5.28436 25.7826 5.28436C32.4598 5.28436 33.2527 5.31056 35.8916 5.42976C38.3305 5.54076 39.6539 5.94976 40.537 6.28976C41.7049 6.74216 42.5382 7.28536 43.4144 8.15976C44.2905 9.03416 44.8308 9.86816 45.2855 11.0354C45.6289 11.9154 46.0351 13.2406 46.146 15.678C46.2673 18.3154 46.2915 19.1048 46.2915 25.781C46.2915 32.4572 46.2673 33.2466 46.146 35.884C46.0349 38.3214 45.6267 39.6462 45.2855 40.5266C44.8308 41.6938 44.2893 42.5266 43.4144 43.4002C42.5394 44.2738 41.7049 44.8158 40.537 45.2702C39.6565 45.6134 38.3305 46.0194 35.8916 46.1302C33.2549 46.2514 32.4628 46.2756 25.7826 46.2756C19.1024 46.2756 18.3125 46.2514 15.6765 46.1302ZM15.4694 0.932162C12.8064 1.05336 10.9867 1.47536 9.39755 2.09336C7.75177 2.73156 6.35853 3.58776 4.9663 4.97696C3.57406 6.36616 2.71955 7.76076 2.08097 9.40556C1.46259 10.9948 1.04034 12.8124 0.919069 15.4738C0.795795 18.1394 0.767578 18.9916 0.767578 25.7808C0.767578 32.57 0.795795 33.4222 0.919069 36.0878C1.04034 38.7494 1.46259 40.5668 2.08097 42.156C2.71955 43.7998 3.57426 45.196 4.9663 46.5846C6.35833 47.9732 7.75177 48.8282 9.39755 49.4682C10.9897 50.0862 12.8064 50.5082 15.4694 50.6294C18.138 50.7506 18.9893 50.7808 25.7826 50.7808C32.5759 50.7808 33.4286 50.7526 36.0958 50.6294C38.759 50.5082 40.5774 50.0862 42.1676 49.4682C43.8124 48.8282 45.2066 47.9738 46.5989 46.5846C47.9911 45.1954 48.8438 43.7998 49.4842 42.156C50.1026 40.5668 50.5268 38.7492 50.6461 36.0878C50.7674 33.4202 50.7956 32.57 50.7956 25.7808C50.7956 18.9916 50.7674 18.1394 50.6461 15.4738C50.5248 12.8122 50.1026 10.9938 49.4842 9.40556C48.8438 7.76176 47.9889 6.36836 46.5989 4.97696C45.2088 3.58556 43.8124 2.73156 42.1696 2.09336C40.5775 1.47536 38.7588 1.05136 36.0978 0.932162C33.4306 0.810962 32.5779 0.780762 25.7846 0.780762C18.9913 0.780762 18.138 0.808962 15.4694 0.932162Z"
              fill="" />
            <defs>
              <radialGradient id="paint0_radial_7092_54404" cx="0" cy="0" r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(7.41436 51.017) scale(65.31 65.2708)">
                <stop offset="0.09" stop-color="#FA8F21" />
                <stop offset="0.78" stop-color="#D82D7E" />
              </radialGradient>
              <radialGradient id="paint1_radial_7092_54404" cx="0" cy="0" r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(31.1086 53.257) scale(51.4733 51.4424)">
                <stop offset="0.64" stop-color="#8C3AAA" stop-opacity="0" />
                <stop offset="1" stop-color="#8C3AAA" />
              </radialGradient>
            </defs>
            </svg>
            <div className="absolute top-full left-0 w-full h-full rounded-full bg-gradient-to-bl from-purple-500 via-pink-500 to-yellow-500 z-0 transition-all duration-500 group-hover:top-0"></div>
          </a>
    
          {/* WhatsApp button */}
          <a
            href="https://whatsapp.com/channel/0029VaDQkNdJENxy14KDvm38"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 flex items-center relative overflow-hidden justify-center rounded-full bg-white shadow-md shadow-gray-200 group transition-all duration-300"
          >            
            <svg className="fill-gray-900 relative z-10 transition-all duration-300 group-hover:fill-white" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 71 72" fill="none">
            <path
              d="M12.5762 56.8405L15.8608 44.6381C13.2118 39.8847 12.3702 34.3378 13.4904 29.0154C14.6106 23.693 17.6176 18.952 21.9594 15.6624C26.3012 12.3729 31.6867 10.7554 37.1276 11.1068C42.5685 11.4582 47.6999 13.755 51.5802 17.5756C55.4604 21.3962 57.8292 26.4844 58.2519 31.9065C58.6746 37.3286 57.1228 42.7208 53.8813 47.0938C50.6399 51.4668 45.9261 54.5271 40.605 55.7133C35.284 56.8994 29.7125 56.1318 24.9131 53.5513L12.5762 56.8405ZM25.508 48.985L26.2709 49.4365C29.7473 51.4918 33.8076 52.3423 37.8191 51.8555C41.8306 51.3687 45.5681 49.5719 48.4489 46.7452C51.3298 43.9185 53.1923 40.2206 53.7463 36.2279C54.3002 32.2351 53.5143 28.1717 51.5113 24.6709C49.5082 21.1701 46.4003 18.4285 42.6721 16.8734C38.9438 15.3184 34.8045 15.0372 30.8993 16.0736C26.994 17.11 23.5422 19.4059 21.0817 22.6035C18.6212 25.801 17.2903 29.7206 17.2963 33.7514C17.293 37.0937 18.2197 40.3712 19.9732 43.2192L20.4516 44.0061L18.6153 50.8167L25.508 48.985Z"
              fill="" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M44.0259 36.8847C43.5787 36.5249 43.0549 36.2716 42.4947 36.1442C41.9344 36.0168 41.3524 36.0186 40.793 36.1495C39.9524 36.4977 39.4093 37.8134 38.8661 38.4713C38.7516 38.629 38.5833 38.7396 38.3928 38.7823C38.2024 38.8251 38.0028 38.797 37.8316 38.7034C34.7543 37.5012 32.1748 35.2965 30.5122 32.4475C30.3704 32.2697 30.3033 32.044 30.325 31.8178C30.3467 31.5916 30.4555 31.3827 30.6286 31.235C31.2344 30.6368 31.6791 29.8959 31.9218 29.0809C31.9756 28.1818 31.7691 27.2863 31.3269 26.5011C30.985 25.4002 30.3344 24.42 29.4518 23.6762C28.9966 23.472 28.4919 23.4036 27.9985 23.4791C27.5052 23.5546 27.0443 23.7709 26.6715 24.1019C26.0242 24.6589 25.5104 25.3537 25.168 26.135C24.8256 26.9163 24.6632 27.7643 24.6929 28.6165C24.6949 29.0951 24.7557 29.5716 24.8739 30.0354C25.1742 31.1497 25.636 32.2144 26.2447 33.1956C26.6839 33.9473 27.163 34.6749 27.6801 35.3755C29.3607 37.6767 31.4732 39.6305 33.9003 41.1284C35.1183 41.8897 36.42 42.5086 37.7799 42.973C39.1924 43.6117 40.752 43.8568 42.2931 43.6824C43.1711 43.5499 44.003 43.2041 44.7156 42.6755C45.4281 42.1469 45.9995 41.4518 46.3795 40.6512C46.6028 40.1675 46.6705 39.6269 46.5735 39.1033C46.3407 38.0327 44.9053 37.4007 44.0259 36.8847Z"
              fill="" />
            </svg>
            <div className="absolute top-full left-0 w-full h-full rounded-full bg-green-400 z-0 transition-all duration-500 group-hover:top-0"></div>
          </a>
      
        
          {/* LinkedIn icon */}
          <a
            href="https://www.linkedin.com/in/hicham-zarouri-87217249/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 flex items-center relative overflow-hidden justify-center rounded-full bg-white shadow-md shadow-gray-200 group transition-all duration-300"
          >            
          <svg className="fill-gray-900 relative z-10 transition-all duration-300 group-hover:fill-white"  xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 72 72" fill="none">
            <path d="M24.7612 55.999V28.3354H15.5433V55.999H24.7621H24.7612ZM20.1542 24.5591C23.3679 24.5591 25.3687 22.4348 25.3687 19.7801C25.3086 17.065 23.3679 15 20.2153 15C17.0605 15 15 17.065 15 19.7799C15 22.4346 17.0001 24.5588 20.0938 24.5588H20.1534L20.1542 24.5591ZM29.8633 55.999H39.0805V40.5521C39.0805 39.7264 39.1406 38.8985 39.3841 38.3088C40.0502 36.6562 41.5668 34.9455 44.1138 34.9455C47.4484 34.9455 48.7831 37.4821 48.7831 41.2014V55.999H58V40.1376C58 31.6408 53.4532 27.6869 47.3887 27.6869C42.4167 27.6869 40.233 30.4589 39.0198 32.347H39.0812V28.3364H29.8638C29.9841 30.9316 29.8631 56 29.8631 56L29.8633 55.999Z" 
            fill=""/>
            </svg>
            <div className="absolute top-full left-0 w-full h-full rounded-full bg-[#006699] z-0 transition-all duration-500 group-hover:top-0"></div>
          </a>
        
          {/* Telegram icon */}
          <a
            href="https://youtube.com/@zhm_ca_fonctionne?feature=shared"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 flex items-center relative overflow-hidden justify-center rounded-full bg-white shadow-md shadow-gray-200 group transition-all duration-300"
          >
            <svg
              className="fill-gray-900 relative z-10 transition-all duration-300 group-hover:fill-white"
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 72 72"
              fill="none"
            >
              <path
                d="M61.1026 23.7185C60.5048 21.471 58.7363 19.6981 56.4863 19.0904C52.4181 18 36.0951 18 36.0951 18C36.0951 18 19.7805 18 15.7039 19.0904C13.4622 19.6897 11.6937 21.4627 11.0876 23.7185C10 27.7971 10 36.3124 10 36.3124C10 36.3124 10 44.8276 11.0876 48.9063C11.6854 51.1537 13.4539 52.9267 15.7039 53.5343C19.7805 54.6247 36.0951 54.6247 36.0951 54.6247C36.0951 54.6247 52.4181 54.6247 56.4863 53.5343C58.728 52.935 60.4965 51.162 61.1026 48.9063C62.1902 44.8276 62.1902 36.3124 62.1902 36.3124C62.1902 36.3124 62.1902 27.7971 61.1026 23.7185Z"
                fill=""
              />
              <path
                className="fill-white transition-all duration-300 group-hover:fill-[#FF3000]"
                d="M30.8811 44.1617L44.4392 36.3124L30.8811 28.463V44.1617Z"
              />
            </svg>
            <div className="absolute top-full left-0 w-full h-full rounded-full bg-[#FF3000] z-0 transition-all duration-500 group-hover:top-0"></div>
          </a>
        </div>

        {/* Section contact */}
        <div className="text-white text-center font-bold text-xl md:text-2xl lg:text-4xl">
          <p>
            POUR UNE DEMANDE DE DEVIS OU D'INFORMATIONS :<button className= "text-cyan-500 px-4 py-2" onClick={openModal}>NOUS ÉCRIRE
            </button>
          </p>
          
          {/*Modal */}
          {isModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg p-6 max-w-lg mx-auto z-50">
              <form onSubmit={sendEmail}>
                {/* Nom */}
                <div className="mb-4">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700">Nom</label>
                  <input
                    type="text"
                    id="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 text-black"
                    required
                  />
                </div>

                {/* Prénom */}
                <div className="mb-4">
                  <label htmlFor="lastname" className="block text-sm font-medium text-gray-700">Prénom</label>
                  <input
                    type="text"
                    id="lastname"
                    value={formData.lastname}
                    onChange={handleChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 text-black"
                    required
                  />
                </div>

                {/* Email */}
                <div className="mb-4">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700">E-mail</label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 text-black"
                    required
                  />
                </div>

                {/* Services Dropdown */}
                <div className="mb-4">
                  <label htmlFor="services" className="block text-sm font-medium text-gray-700">Prestations</label>
                  <select
                    id="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 text-black"
                    required
                  >
                    <option value="">-- Sélectionnez un service --</option>
                    <option value="ZHTECH">ZHTECH</option>
                    <option value="ZHWEB">ZHWEB</option>
                    <option value="ZHMOTION">ZHMOTION</option>
                    <option value="ZHPHOTOS">ZHPHOTOS</option>
                    <option value="ZHDESIGN">ZHDESIGN</option>
                  </select>
                </div>

                {/* Message */}
                <div className="mb-4">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700">Message</label>
                  <textarea
                    id="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 text-black"
                    required
                  ></textarea>
                </div>

                {/* Boutons */}
                <div className="flex justify-end">
                  <button
                    type="submit"
                    className="bg-cyan-600 text-white px-4 py-2 rounded hover:bg-cyan-700 transition duration-300 mr-2"
                  >
                    Envoyer
                  </button>
                  <button
                    type="button" 
                    className= "submit-button bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400 transition duration-300"
                    onClick={closeModal}
                  >
                    Fermer
                  </button>
                </div>
              </form>
            </div>
          </div>
          )}
        </div>
        <br />

        {/* Slogan */}
        <img src="/img/slogan.png" alt="Slogan ZHM" className="h-20 mx-auto mb-4" />
        {/* Copyright */}
        <footer className="text-white py-4">
          <div className="container mx-auto text-center">
            <p className="text-sm md:text-base">
              &copy; 2024 - Tous droits réservés. Design et développement : <button className="font-semibold text-white"> 
              ZHWEB 
              </button>
            </p>
          </div>
        </footer>
      </section>
    </div>
  ); 
};

export default App;